import React 		from 'react'
import classnames 	from 'classnames'
import Helmet 		from 'react-helmet'
import {
	connect
} from 'react-redux'
import {
	TransitionGroup,
	CSSTransition,
	Transition
} from 'react-transition-group'
import PS 			from 'publish-subscribe-js'

import {
	togglePageTransitioning
} from '../../redux/actions'

class PageTransition extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			children,
			location,
			dispatch,
			pageIsTransitioning
		} = this.props

		return <TransitionGroup
			component={ null }>
			<CSSTransition
				key={ location.pathname }
				mountOnEnter={ true }
				unmountOnExit={ true }
				classNames="pageFade-"
				timeout={ {
					enter: 1600,
 					exit: 600
				} }
				onEnter={ () => {
					dispatch(togglePageTransitioning(true))
				} }
				onEntered={ () => {
					dispatch(togglePageTransitioning(false))
				} }
				>
				<div className="page">
					{ children }
				</div>
			</CSSTransition>
		</TransitionGroup>
	}
}

const mapStateToProps = (state) => {
	const {
		ui
	} = state

    return {
    	pageIsTransitioning: ui.pageIsTransitioning
    }
}

export default connect(mapStateToProps, null)(PageTransition)